import styled from "styled-components";

const Grid = styled.div`
  display: flex;
  justify-content: space-evenly;
  .content-wrapper {
    text-align: center;
    margin-top: 0;
    width: 100%;
    margin-bottom: 5px;
    margin-top: 5px;
    span {
      font-size: 18px;
      font-family: "Nunito";
    }
    legend {
      text-transform: uppercase;
      font-size: 12px;
      white-space: nowrap;
      letter-spacing: 1px;
    }
  }
  @media screen and (max-width: 767px) {
    padding: 0 15px;
    margin-top: 20px;
    &.contract,
    &.project {
      display: grid !important;
      grid-template-columns: 2fr 2fr;
      grid-gap: 15px;
      .content-wrapper {
        box-shadow: 0 3px 3px rgba(34, 34, 34, 0.1) !important;
        margin: 0;
        border-radius: 5px;
        padding: 15px;
      }
    }
  }
`;

export default Grid;
